import { auth } from "@/lib/firebase";
import type { ErrorCode } from "@/utils/errorCode";
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import Axios from "axios";

const domainApiUrl = import.meta.env["VITE_REACT_APP_DOMAIN_API_URL"];
const hubApiUrl = import.meta.env["VITE_REACT_APP_HUB_APP_URL"];
interface CustomErrorDetail {
  error: ErrorCode;
  message: string;
}

interface ErrorResponseData {
  detail: string | CustomErrorDetail;
}

export interface CustomAxiosError extends AxiosResponse {
  response?: {
    data: ErrorResponseData;
    request: {
      status: number;
    };
  };
}

// エラーコードを取得するユーティリティ関数
export function GetErrorCode(error: CustomAxiosError): ErrorCode | undefined {
  if (
    typeof error.response?.data.detail === "object" &&
    "error" in error.response.data.detail
  ) {
    return error.response.data.detail.error;
  }
  return undefined;
}

async function authRequestInterceptor(config: AxiosRequestConfig) {
  const token = await auth.currentUser?.getIdToken();

  // config.headersが存在することを保証します
  config.headers = config.headers || {};
  if (token) {
    config.headers["authorization"] = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config as InternalAxiosRequestConfig;
}

export const hubApiClient = Axios.create({
  baseURL: hubApiUrl,
});

export const axiosAuth = Axios.create({
  baseURL: domainApiUrl,
});

axiosAuth.interceptors.request.use(authRequestInterceptor);
axiosAuth.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

hubApiClient.interceptors.request.use(authRequestInterceptor);
hubApiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
